<template>
    <div>
        <Header></Header>

        <div class="row py-3 mb-4 justify-content-between pageTitleDiv">
            <div class="container pl-0">
                <div class="h1 mb-0 d-flex align-items-center font-lg pageTitle">
                    {{$ml.get('PERSONS')}}
                    <span class="font-12 py-1 px-2 bg-new-badges border-radius-20 ml-2">{{totalCount}}</span>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row py-3 mb-4 justify-content-between pageTitleDiv2">
                <div class="container pl-0">
                    <div class="h1 mb-0 d-flex align-items-center font-lg pageTitle">
                        {{$ml.get('PERSONS')}}
                        <span class="font-12 py-1 px-2 bg-new-badges border-radius-20 ml-2">{{totalCount}}</span>
                    </div>
                </div>
            </div>
            <div class="row mb-2 justify-content-between">
                <div class="d-flex" v-if="windowWidth>maxMobilSize">
                    <div class="float-left mr-2 table-setting" v-if="$can('can_bulk_delete_contacts')">
                        <button type="button" :title="$ml.get('BULK_ACTIONS')" class="btn btn-crm-secondary dropdown-toggle h40" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> 
                            <label class="p-0 m-0 btn-click">{{$ml.get('BULK_ACTIONS')}}</label>
                        </button>
                        <div class="dropdown-menu dropdown-menu-left dropMenu multiChoose p-0">
                            <ul class="new-dropdown p-0 border-0">
                                <li class="" @click="openBulkUpdateModal()"><i class="fa fa-exchange h-14"></i> {{$ml.get('BULK_UPDATE')}}</li>
                                <li class="text-danger" @click="deleteSelectedRows()" v-if="$can('can_bulk_delete_contacts')"><i class="fa fa-trash h-14"></i> {{$ml.get('DELETE')}}</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="d-flex">
                    <div class=" addBtn" data-toggle="modal" data-target="#add" @click="clearModal=false">
                        <button type="button" @click="activaTabContact()" class="btn bg-new-primary f-14 h-100">
                            <i class="fa fa-plus f-14 mr-2"></i> {{$ml.get('ADD_PERSON')}}
                        </button>   
                    </div>
            
                    <filterComponent class="newFilterButton" @filter="filter=$event,getContacts('emitter')" :customFields="this.customFields" :users="this.users"/>

                    <div class="float-left mr-2 ml-2 table-setting">
                        <button type="button" :title="$ml.get('SET_COLUMNS')" class="btn-crm-secondary btn btn-click p-2 dropdown-button h40 w40" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> 
                            <i class="fa fa-gear font-m "></i>
                        </button>
                        <div class="dropdown-menu dropdown-menu-right dropMenu multiChoose p-0">
                            <div class="p-2 mcBgDark">
                                <span class="text-white">{{selectedTableView.name}}</span>
                            </div>
                            <ul class="new-dropdown p-0 border-0">
                                <li class="p-0" v-for="col in gridColumns" v-show="(col['prop']!=='_id'&&col['prop']!=='x'&&col['prop']!=='notes'&&col['prop']!=='currency')">
                                    <label class="w-100 custom-checkbox">
                                        <input type="checkbox" :value="col['prop']" :disabled="tableConfigVisible.length <= 1 && tableConfigVisible.indexOf(col['prop']) != -1" v-model="tableConfigVisible"> 
                                        <span class="label-text f-14">{{col['name']}}</span>
                                    </label>
                                </li>
                            </ul>
                            <div class="dd-footer p-1">
                                <button type="button" data-toggle="modal"  data-target="#colListModal"  class="btn" style="background-color: #fff !important;color:#333333;border:1px solid #dcdddd">{{$ml.get('SAVED_VIEWS')}}</button>
                                <button type="button" @click="selectSaveMethod()" class="btn bg-new-primary" style="background-color:#1891eb !important"><i class="fa fa-save"></i> {{$ml.get('SAVE')}}</button>
                            </div>
                        </div>
                    </div>

                <div class="table-setting">
                  <button type="button" :title="$ml.get('SET_COLUMNS')" class="btn-crm-secondary btn btn-click p-2 dropdown-button h40 w40" data-toggle="dropdown"  aria-haspopup="true" aria-expanded="false"> 
                      <i class="fa fa-ellipsis-v font-m "></i>
                  </button>
                  <div class="dropdown-menu dropdown-menu-right dropMenu multiChoose p-0">
                      <ul class="new-dropdown p-0 border-0">
                          <li>
                            <a class="" @click="importFile"  v-if="$can('can_use_import')">
                                {{$ml.get('IMPORT_EXCEL')}}
                                <i class="fas fa-file-import float-left pr-2" style="padding-top:11px;">
                                        <!-- <img src="../assets/xls-icon.png" width="23px"> -->
                                </i>
                            </a>
                          </li>
                          <li>
                            <a class="" @click="exportContactsF" v-if="$can('can_export_data_from_lists')">
                                {{$ml.get('EXPORT_EXCEL')}}
                                <i class="fas fa-file-export float-left pr-2" style="padding-top:11px;">
                                    <!-- <img src="../assets/xls-icon.png" width="23px"> -->
                                </i>
                            </a>
                          </li>
                      </ul>
                  </div>
                </div>

                </div>
            </div>
            <div class="alert alert-secondary alert-dismissible fade show" v-if="totalCount == 0" role="alert">
            <strong>{{$ml.get('WARNING')}}</strong>
            {{$ml.get('NOT_FOUND_MESSAGE')}}
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">×</span>
            </button>
            </div>

            <grid v-if="windowWidth>maxMobilSize" :data="gridData" @updateCheckedRows="updateCheckedRows($event)" @editContact="getContactData($event)" @sortedData="getSortedData($event)" :tableConfigVisible="tableConfigVisible" :columns="gridColumns" :cellUpdateUrl="contactUpdate" :permissions="permissions" :user="user" :users="users" :filterGuide="guideCol" @scrolled="scrollfunctionOfGrid" :page="pageIs"></grid>
            <gridMobil v-else :data="gridData" @updateCheckedRows="updateCheckedRows($event)" @editContact="getContactData($event)" @sortedData="getSortedData($event)" :tableConfigVisible="tableConfigVisible" :columns="gridColumns" :cellUpdateUrl="contactUpdate" :permissions="permissions" :user="user" :users="users" :filterGuide="guideCol" @scrolled="scrollfunctionOfGrid" :page="pageIs"></gridMobil>
            
            <div class="modal fade" id="add" ref="vuemodal" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document" style="max-width:800px!important">
                    <div class="modal-content crm-modal-content">
                        <newContact 
                        ref="newContact" 
                        @updateList="getContacts('emitter')" 
                        :user="this.user" 
                        :clearModal="clearModal" 
                        :isEditMode="isEditMode" 
                        :data="contactData" :users="this.users" 
                        :customFieldArray="customFields"
                        ></newContact>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="importFile" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog mw-100 w-75" role="document" >
                <div class="modal-content">
                        <takeImport :columns="gridColumns" :page="pageIs" @closeTakeModal="getContacts('emitter')"></takeImport>  
                </div>
                </div>
            </div>

            <notifications group="foo" style="margin-right:5%;margin-top:5%" position="top right" />

             <!-- Toplu işlem Alan Değiştirme Modal Başlangıç -->
       <div class="modal fade "  id="bulkUpdate" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="bulkUpdateModal" aria-hidden="true">
                <div class="modal-dialog modal-xl modal-dialog-centered" role="document" >
                    <div class="modal-content mcBgGrey">
                        <div class="modal-header border-0 mt-2 pb-0 align-items-center">
                            <h5 class="modal-title font-weight-bold">{{$ml.get('BULK_FIELD_UPDATE')}}</h5>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12" v-for="(col,index) in bulkEditableColumns" v-bind:key="index">
                                    <div class="input-group mb-3">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">{{col.name}}</span>
                                        </div>
                                        <select class="custom-select" v-model="col.val">
                                            <option value="">{{$ml.get('SELECT')}}</option>
                                            <option :value="user._id.$oid" v-for="(user,ind) in users" v-bind:key="ind">{{user.name}} {{user.surName}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <div class="col-12 dealBtnStyle p-0">
                                <button class="btn-new save" @click="updateContactsF()">{{$ml.get('BULK_UPDATE_BTN_TXT')}}</button>
                                <button class="btn-new" data-dismiss="modal" aria-label="Close">
                                    {{$ml.get('CANCEL')}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

      <!-- Toplu işlem Alan Değiştirme Modal Bitiş  -->
        <div class="modal fade" id="colListModal" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="collist" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content mcBgGrey">
                    <div class="modal-header border-0 mt-2 pb-0 align-items-center">
                            <h5 class="h5" id="saveColListModalTitle">{{$ml.get('SAVED_VIEWS')}}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true" class="font-40">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                      <ul class="list-group radio-list-group" >
                          <li class="list-group-item">
                              <label for="" class="">
                                  <input type="radio" name="selectedview" v-model="selectedTableView" :value="defaultTableView"> {{$ml.get('DEFAULT_VIEW')}}
                              </label>
                          </li>
                          <li class="list-group-item" v-for="(view,index) in tableViewList"   v-bind:key="index">
                              <label for="" class="">
                                        <input type="radio" name="selectedview" v-model="selectedTableView" :value="view" > {{view.name}}
                              </label>
                              <i class="fa fa-trash text-danger" @click="deleteTableViewF(view._id.$oid)"></i>
                          </li>
                      </ul>
                    </div>
                    <div class="modal-footer">
                      <div class="col-12 dealBtnStyle p-0">
                          <button class="btn-new save" v-if="tableViewList.length>0"   @click="setTableViewF(selectedTableView._id.$oid)">
                                    {{$ml.get('APPLY')}}
                          </button>
                          <button class="btn-new" data-dismiss="modal" aria-label="Close">{{$ml.get('CANCEL')}}</button>
                      </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="selectMethodModal" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="savecollist" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content mcBgGrey">
                    <div class="modal-header border-0 mt-2 pb-0 align-items-center">
                          <h5 class="h5" id="saveColListModalTitle">{{$ml.get('SAVE_VIEW')}}</h5>
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true" class="font-40">&times;</span>
                          </button>
                    </div>
                    <div class="modal-body">
                          “{{selectedTableView.name}}” {{$ml.get('WHICH_WAY_TO_SAVE')}}
                    </div>
                    <div class="modal-footer">
                        <div class="col-12 dealBtnStyle p-0">
                              <button class="btn-new save mcBgDark" data-dismiss="modal" aria-label="Close" data-toggle="modal"  data-target="#saveTableViewModal" >
                                    {{$ml.get('SAVE_AS')}}
                              </button>
                              <button class="btn-new save" @click="updateTableViewF()">
                                    {{$ml.get('OVERWRITE')}}
                              </button>
                              <button class="btn-new" data-dismiss="modal" aria-label="Close">{{$ml.get('CANCEL')}}</button>
                        </div>
                    </div>
              </div>
            </div>
        </div>

        <div class="modal fade" id="saveTableViewModal" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="savecollist" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content mcBgGrey">
                    <div class="modal-header border-0 mt-2 pb-0 align-items-center">
                        <h5 class="h5" id="saveColListModalTitle">{{$ml.get('SAVE_VIEW')}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true" class="font-40">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <label for="" class="">{{$ml.get('NAME_VIEW')}}</label>
                        <input type="text" class="form-control" v-model="newTableView.name">      
                    </div>
                    <div class="modal-footer">
                        <div class="col-12 dealBtnStyle p-0">
                            <button class="btn-new save" @click="saveTableViewF()">{{$ml.get('SAVE')}}</button>
                            <button class="btn-new" data-dismiss="modal" aria-label="Close">
                                {{$ml.get('CANCEL')}}
                            </button>
                        </div>
                    </div>
                </div>
          </div>
        </div>
        </div>    
    </div>    
</template>

<script>
import Header from './header'
import Grid from './Grid'
import GridMobil from "./gridMobil"
import axios from 'axios'
import newContact from './newContact.vue'
import filterComponent from './filterComponent.vue'
import takeImport from './import.vue'
import Swal from 'sweetalert2'
import { mapState } from 'vuex'
import {mapActions} from 'vuex'
export default {
    components: {
        Header,
        Grid,
        GridMobil,
        "newContact":newContact,
        "filterComponent":filterComponent,
        "takeImport":takeImport
    },
    name:'Activities',
    data (){
        return {
            contacts:[],
            customFields:[],
            gridColumns: [
                {prop:'_id',name:"Id"},
                {prop:'cuid', name: this.$ml.get('HOLDER'), type:"user", default:false},
                {prop:'n',name:this.$ml.get('NAME'),type:"contactName", default:true,valid:true},
                {prop:'sn',name:this.$ml.get('SURNAME'), default:true},
                {prop:'jobTitle',name:this.$ml.get('JOBTITLE'), default:true},
                {prop:'organization',name:this.$ml.get('RELATED_COMPANY'),type:"organizations",isSort:false},
                {prop:'tck',name:this.$ml.get('TCK')},
                {prop:'gsm',name:"Gsm", default:true,type:"phones"},
                {prop:'phone',name:this.$ml.get('LANDLINE'),type:"phones"},
                {prop:'addr',name:this.$ml.get('ADDRESS')},
                {prop:'fax',name:this.$ml.get('FAX'),type:"phones"},
                {prop:'email',name:this.$ml.get('E_MAIL'), default:true,type:"emailAddresses"},
                {prop:'country',name:this.$ml.get('COUNTRY'),type:'country'},
                {prop:'city',name:this.$ml.get('CITY'),type:'city', default:true},
                {prop: "town", name: this.$ml.get('DISTRICT'), type: "town"},
                {prop:"createdAt",name:this.$ml.get('CREATION_DATE'), type: "dateObj" }
                //{prop:'dob',name:"Doğum Tarihi",type:"dateObj"},
                //{prop:'wed_ann',name:"Evlilik Yıldönümü",type:"dateObj"}
            ],
            gridData:[],
            pagingSize:30,
            pagingOffset:0,
            totalCount:0,
            bottom:false,
            contactUpdate:'updateContact',
            guideCol:'n',// name column will be filtered by first letter
            user:[],
            users:[],
            filter:"",
            clearModal:false,
            pageIs:"contact",
            permissions:[],
            tableConfigVisible:[],
            sort:null,
            sortType:null,
            contactsRow:[],
            contactData:[],
            isEditMode:false,
            firstLoad:true,
            checkedRows:[],
            checkAllRows:false,
            exportLang:"",
            selectedTableView:{
                _id:{$oid:''}
            },
            defaultTableView:{
                name:this.$ml.get('DEFAULT_VIEW'),
                _id:{$oid:'default-view'}
            },
            tableViewList:[],
            newTableView:{
            },
             bulkEditableColumns: [
                { prop: "cuid", name: this.$ml.get('HOLDER'), val:"", type: "user" },//sahibi   
            ],
        }
    },
    watch: {
        bottom(bottom) {
            if (bottom) {
                    this.pagingOffset+=this.pagingSize
                    this.getContacts()
            }
        },
        permissions:function(){
            if(this.permissions===undefined){
                this.permissions=[]
            }
        }
    },
    methods:{
        updateCheckedRows(val){
            console.log("checked rows val")
            console.log(val)
            if(val=='allRowsChecked'){
                this.checkAllRows=true
                this.checkedRows = []
            }else{
                this.checkAllRows=false
                this.checkedRows = val
            }
        },
        deleteSelectedRows(){
            if(this.checkedRows.length==0&&this.checkAllRows==false){
                Swal.fire({
                    title: this.$ml.get('WARNING'),
                    text: this.$ml.get('NO_SELECTED_ROW_ON_DELETE'),
                    icon: "warning"
                })
                return false
            }

            var form = {}

             if(this.checkAllRows==true&&this.filter==''){
                form.all = true
            }else if(this.checkedRows.length>0){
                form.contactIds = this.checkedRows
            }
            
            if(this.filter!==''&&this.checkedRows.length==0){
                form.filter = this.filter
            }

            var confirm_message = this.$ml.get('DELETE_RECORDS_CONFIRM')
            if(this.$can('can_bulk_delete_contacts')&&this.$can('can_delete_other_users_contacts')){
                confirm_message = this.$ml.get('DELETE_RECORDS_CONFIRM')
            }else if(!this.$can('can_bulk_delete_contacts')&&this.$can('can_delete_other_users_contacts')){
                confirm_message = this.$ml.get('DELETE_RECORDS_CONFIRM_OTHERS')
            }else if(this.$can('can_bulk_delete_contacts')&&!this.$can('can_delete_other_users_contacts')){
                confirm_message = this.$ml.get('DELETE_RECORDS_CONFIRM_OWN')
            }

            Swal.fire({
                title: this.$ml.get('DELETE_RECORDS'),
                text: confirm_message,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: '#d33',
                confirmButtonText: this.$ml.get('DELETE_RECORDS_CONFIRM_BTN_TXT'),
                cancelButtonText: this.$ml.get('CANCEL'),
                customClass:{
                    icon:'custom-delete-warning',
                    cancelButton:'custom-delete-cancel-button'
                },
                reverseButtons:true
            }).then((result)=>{
                if(result.isConfirmed){
                    this.deleteContacts(form).then((response)=>{
                        if(response.status.code=='0'){
                            this.$notify({ 
                                group: 'foo',
                                type: 'success', 
                                title: this.$ml.get('SUCCESSFUL'),
                                text: response.status.desc 
                            })
                            this.getContacts('emitter')
                        }else{
                            this.$notify({ 
                                group: 'foo',
                                type: 'error', 
                                title: this.$ml.get('ERROR'),
                                text: response.status.desc 
                            })
                        }
                    })
                }
            })
            
        },
        getContactData(contactId){
            this.isEditMode=true
            this.contactData = this.contactsRow.find(item => item._id.$oid === contactId);
            $('#add').modal('show')
        },
        getSortedData(form){
            this.sort=form.sort
            this.sortType=form.sortType
            this.getContacts('emitter')
        },
        exportContactsF(){

             
            axios({
                method:'POST',
                url:'/exportContacts',
                data:{
                    language:this.exportLang
                },
                baseURL: this.baseUrl,
                withCredentials:true
            }).then((res)=>{
                    return res
            }).then((res)=>{
                
                 
                if(res.data.status.code==0 && res.data.content.link){
                    window.open(res.data.content.link,'_blank')
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc 
                    })
                }
            })
        },
        scrollfunctionOfGrid:function (scrollYEmit,clientHeightEmit,scrollHeightEmit){
            this.bottom = this.bottomVisible(scrollYEmit,clientHeightEmit,scrollHeightEmit)
        },
        bottomVisible(scrollYEmit,clientHeightEmit,scrollHeightEmit) {
            
            const scrollY = scrollYEmit
            const visible = clientHeightEmit
            const pageHeight = scrollHeightEmit
            const bottomOfPage = visible + scrollY >= pageHeight
            
            return bottomOfPage || pageHeight < visible
        },
        updateList(event){
            
            let obj={}

            let productObj =event
            let columns =this.gridColumns

                
            for(var column in columns){

                var colInProduct = productObj.hasOwnProperty(columns[column]['prop'])

                if(colInProduct){
                    let edObj={}

                    edObj['val']=productObj[columns[column]['prop']]
                    edObj['isEditMode']=false
                    edObj['type']=columns[column]['type']

                    obj[columns[column]['prop']]=edObj
                }else{
                    let edObj={}

                    edObj['val']=null
                    edObj['isEditMode']=false
                    edObj['type']=columns[column]['type']
                    obj[columns[column]['prop']]=edObj
                }
            }
            
            this.contacts.push(obj)
            this.totalCount=this.totalCount+1
        },
        getContacts(emitter){
            
            if(this.windowWidth<this.maxMobilSize){
                this.gridColumns= [
                    {prop:'_id',name:"Id"},
                    {prop:'cuid', name: this.$ml.get('HOLDER'), type:"user", default:false},
                    {prop:'n',name:this.$ml.get('NAME'),type:"contactName", default:true,valid:true},
                    {prop:'sn',name:this.$ml.get('SURNAME'), default:true,valid:true},
                    {prop:'jobTitle',name:this.$ml.get('JOBTITLE'),type:"jobTitle", default:true},
                    {prop:'gsm',name:"Gsm", default:true,type:"phones"},
                    {prop:'email',name:this.$ml.get('E_MAIL'), default:true,type:"email"},
                    {prop:'city',name:this.$ml.get('CITY'),type:'city', default:true}
                ]
            }  

            if(emitter!==undefined){
                this.pagingOffset=0
                if(screen.height>720){
                    this.pagingSize=30
                }else{
                    this.pagingSize=30
                }
            }
            var params = {}
            params.pagingSize=this.pagingSize
            params.pagingOffset=this.pagingOffset
            params.filter=this.filter
            if(this.sort!=null){
                params.sort=this.sort
            }
            if(this.sortType!=null){
                params.sortType=this.sortType
            }
            axios({
                method:'POST',
                url:'/getContacts',
                baseURL: this.baseUrl,
                data: params,
                withCredentials:true
            }).then((res)=>{
                    return res
            }).then((res)=>{
                if(!res.data.status){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==0){
                    if(emitter!==undefined){
                        this.contacts=[]
                        this.contactsRow=[]
                    }
                    if(res.data.content.pageInfo){
                        if(res.data.content.pageInfo['totalCount']){
                            this.totalCount = res.data.content.pageInfo['totalCount']
                        }else{
                            this.totalCount = 0
                        }
                    }
                    if(res.data.content.customFields){
                        for (var item in res.data.content.customFields){
                            let obj={}

                            obj['prop']=res.data.content.customFields[item]['_id']['$oid']
                            obj['name']=res.data.content.customFields[item]['name']
                            obj['type']=res.data.content.customFields[item]['field_type']
                            if(res.data.content.customFields[item]['field_type']==4){
                                obj['users']=res.data.users
                            }else if(res.data.content.customFields[item]['field_type']==7||res.data.content.customFields[item]['field_type']==6){
                                obj['options']=res.data.content.customFields[item]['options']
                            }
                            

                            var existingColCount = this.gridColumns.filter(function(i){
                                if(i.name === res.data.content.customFields[item]['name']) return i.name
                            })

                            if(existingColCount.length<1){
                                this.gridColumns.push(obj)
                                // this.bulkEditableColumns.push(obj);
                            }
                        }
                    }
                    

                    if(this.firstLoad){
                        for(var col in this.gridColumns){
                            if(this.gridColumns[col]['default']){
                                this.tableConfigVisible.push(this.gridColumns[col]['prop'])
                            }
                        }
                    }
                    this.firstLoad=false

                    if(res.data.content.contacts){
                        let columns =this.gridColumns

                        for (var contactObjIter in res.data.content.contacts){
                            this.contactsRow.push(res.data.content.contacts[contactObjIter])

                            let obj={}

                            let contactObj =res.data.content.contacts[contactObjIter]
 
                              
                            for(var column in columns){

                                var colInActivity = contactObj.hasOwnProperty(columns[column]['prop'])

                                if(colInActivity){
                                    
                                    let edObj={}
                                    
                                    edObj['val']=contactObj[columns[column]['prop']]
                                    
                                    edObj['isEditMode']=false
                                    edObj['type']=columns[column]['type']

                                    obj[columns[column]['prop']]=edObj
                                }else{
                                    let edObj={}

                                    edObj['val']=null
                                    edObj['isEditMode']=false
                                    edObj['type']=columns[column]['type']
                                    if(columns[column]['type']=='price'){
                                        let pricesList = []
                                        let priceObj = {}
                                        priceObj['currency']=null
                                        priceObj['price']=null
                                        pricesList.push(priceObj)
                                        edObj['val']=pricesList
                                    }else if(columns[column]['type']==4){
                                        let oid = {} 
                                        oid['$oid']=''
                                        edObj['val']={}
                                        edObj['val']['_id']=oid
                                    }else if(columns[column]['type']=='dateObj'){
                                        let date = {}
                                        date['$date']=''
                                        edObj['val']=date
                                    }else if(columns[column]['type']==5){
                                        let priceObj = {}
                                        priceObj['currency']=''
                                        priceObj['value']=''
                                        edObj['val']=priceObj
                                    }else if(columns[column]['type']==6){
                                        let selected = ""
                                        edObj['val']=selected
                                    }else if(columns[column]['type']==7){
                                        let optionsList = []
                                        edObj['val']=optionsList
                                    }else if(columns[column]['type']=='country'){
                                        edObj['val']=''
                                    }

                                    obj[columns[column]['prop']]=edObj
                                }
                            }
                            this.contacts.push(obj)
                        }
                        this.gridData = this.contacts
                    }
			            this.customFields=res.data.content.customFields
                    	this.user=res.data.user
                        this.users=res.data.users
                        this.permissions=res.data.permissions
                         
                }
                else if(res.data.status.code==2054) {         
                    this.$router.push({ path: 'settings', query: { paymentStatus: 'userManagement' } })
                 } 
                else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc
                    })
                     
                }
            })
        },
        ...mapActions([
            'updateLoading',
            'deleteContacts',
            'updateContacts',
            'getTableView',
            'addTableView',
            'updateTableView',
            'deleteTableView'
        ]),
        importFile(){
            $("#importFile").modal("show")
        },
        modalHidden(){
            this.isEditMode=false
            this.contactData = {}
            this.$refs.newContact.clear()
        },
          openBulkUpdateModal(){
            if(this.checkedRows.length==0&&this.checkAllRows==false){
                Swal.fire({
                    title: this.$ml.get('WARNING'),
                    text: this.$ml.get('NO_SELECTED_ROW_ON_UPDATE'),
                    icon: "warning"
                })
            }else if(this.checkAllRows==true&&this.filter==''){
                Swal.fire({
                    title: this.$ml.get('WARNING'),
                    text: this.$ml.get('UPDATE_ALL_RECORDS_CONFIRM'),
                    icon: "warning",
                    buttons: true,
                    dangerMode:true
                }).then((result)=>{
                    if(result.isConfirmed){
                        $('#bulkUpdate').modal('show')
                    }
                })
                
            }else{
                $('#bulkUpdate').modal('show')
            }
            
        },
          closeBulkUpdateModal(){
            $('#bulkUpdate').modal('hide')
            this.clearBulkUpdateModal()
        },
           clearBulkUpdateModal(){
            for(var i in this.bulkEditableColumns){
                //var val = this.bulkEditableColumns[i].val
                var type = this.bulkEditableColumns[i].type
                if(type!==7){
                    this.bulkEditableColumns[i].val = ''
                }else{
                    this.bulkEditableColumns[i].val = []
                }
            }
        },
         updateContactsF(){
            var form = {}

            form.contactUpdateObj = {}
            for(var obj in this.bulkEditableColumns){
                var prop = this.bulkEditableColumns[obj].prop
                var val = this.bulkEditableColumns[obj].val
                var type = this.bulkEditableColumns[obj].type
                
                if(val!==''&&val!==undefined&&typeof(val)!=='object'){
                    if(type=='user'||type=='4'){
                        var userObject = {}
                        userObject['$oid'] = val
                        form.contactUpdateObj[prop] = userObject
                    }else{
                        form.contactUpdateObj[prop] = val
                    }
                }else if(typeof(val)=='object'&&val.length>0){
                        form.contactUpdateObj[prop] = val
                }
            }

            if(this.checkAllRows==true&&this.filter==''){
                form.all = true
            }else if(this.checkedRows.length>0){
                form.contactIds = this.checkedRows
            }
            
            if(this.filter!==''&&this.checkedRows.length==0){
                form.filter = this.filter
            }
            
            this.updateContacts(form).then((response) => {
                
                if(response.status.code=='0'){
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: this.$ml.get('SUCCESSFUL'),
                        text: response.status.desc 
                    })
                     this.getContacts('emitter')
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: response.status.desc 
                    })
                }
                this.closeBulkUpdateModal()
            }).catch(e => {
                console.log(e)
            })
            
        },
        activaTabContact(){
            this.$root.$refs.newContact.activaTabContact()
        },
        selectSaveMethod(){
            if(this.selectedTableView._id.$oid=='default-view'&&this.tableViewList.length==0){
                $('#saveTableViewModal').modal('show')
            }else{
                $('#selectMethodModal').modal('show')
            }
        },
        getTableViewF(){
            var form = {}
            form.tableName = 'contacts'
            this.getTableView(form).then((res)=>{
                return res
            }).then((res)=>{
                console.log("res.status.code")
                console.log(res)
                if(res.status.code=='0'){
                    this.tableViewList = res.content.tableViews

                    if(this.tableViewList.length>0){
                        
                        var getSelectedCustomView = this.tableViewList.filter(view => view.isDefault ==true)[0]
                        
                        if(getSelectedCustomView==undefined){
                            this.setDefaultTableViewF()
                        }else{
                            this.selectedTableView = getSelectedCustomView
                            this.tableConfigVisible = this.selectedTableView.fields
                            console.log('custom-view set')
                        }
                        
                    }else{
                        this.setDefaultTableViewF()
                    }
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.status.desc 
                    })
                }
            })
        },
        setDefaultTableViewF(){
            var defaultViews = this.gridColumns.filter(col => col.default == true).map(item => item.prop)
            this.tableConfigVisible = defaultViews
            this.defaultTableView.fields = this.tableConfigVisible
            this.defaultTableView.name = this.$ml.get('DEFAULT_VIEW')
            this.selectedTableView = this.defaultTableView
            console.log('custom-view set')   
        },
        setTableViewF(tableViewId){
            if(tableViewId == 'default-view'){
                //this.setDefaultTableViewF()
                var form = {}
                form.tableViewId = this.tableViewList.filter(view => view.isDefault ==true)[0]._id.$oid
                form.isDefault = false
                this.updateTableView(form).then((res)=>{
                    return res
                }).then((res)=>{
                    if(res.status.code=="0"){
                        this.$notify({ 
                            group: 'foo',
                            type: 'success', 
                            title: this.$ml.get('SUCCESSFUL'),
                            text: res.status.desc 
                        })
                        $('#colListModal').modal('hide')
                        this.getTableViewF()
                    }else{
                        this.$notify({ 
                            group: 'foo',
                            type: 'error', 
                            title: this.$ml.get('ERROR'),
                            text: res.status.desc 
                        })
                    }
                })
            }else{
                var theView = this.tableViewList.filter((item)=>{
                    return item._id.$oid == tableViewId
                })
                var form = {}
                this.tableConfigVisible = theView[0].fields
                this.selectedTableView = theView[0]
                
                form.tableViewId = this.selectedTableView._id.$oid
                form.isDefault = true
                this.updateTableView(form).then((res)=>{
                    return res
                }).then((res)=>{
                    if(res.status.code=="0"){
                        this.$notify({ 
                            group: 'foo',
                            type: 'success', 
                            title: this.$ml.get('SUCCESSFUL'),
                            text: res.status.desc 
                        })
                        $('#colListModal').modal('hide')
                        this.getTableViewF()
                    }else{
                        this.$notify({ 
                            group: 'foo',
                            type: 'error', 
                            title: this.$ml.get('ERROR'),
                            text: res.status.desc 
                        })
                    }
                })
            } 
        },
        saveTableViewF(){
            var actualName = this.newTableView.name
            var duplicatedNames = this.tableViewList.filter((item)=>{
                return item.name == actualName
            })  
            if(duplicatedNames.length>0){
                $('#saveTableViewModal').modal('hide')
                $('#confirmOverwriteModal').modal('show')
            }else if(actualName=='Standart görünüm'||actualName=='Default view'){
                Swal.fire({
                    title: this.$ml.get('WARNING'),
                    text: this.$ml.get('ENTER_ANOTHER_NAME'),
                    icon: 'warning'
                })
            }else{
                this.addTableViewF()
            }
            
        },
        addTableViewF(){
            var form = {}
            form.fields = this.tableConfigVisible
            form.tableName = 'contacts'
            form.name = this.newTableView.name
            form.isDefault = false
            this.addTableView(form).then((res)=>{
                return res
            }).then((res)=>{
                console.log(res);
                if(res.status.code=="0"){
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: this.$ml.get('SUCCESSFUL'),
                        text: res.status.desc 
                    })
                    $('#saveTableViewModal').modal('hide')
                    $('#confirmOverwriteModal').modal('hide')
                    this.getTableViewF()
                }
            })
        },
        updateTableViewF(){
            var form = {}
            form.fields = this.tableConfigVisible
            form.tableViewId = this.selectedTableView._id.$oid
            form.name = this.selectedTableView.name
            form.isDefault = this.selectedTableView.isDefault
            this.updateTableView(form).then((res)=>{
                return res
            }).then((res)=>{
                if(res.status.code=="0"){
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: this.$ml.get('SUCCESSFUL'),
                        text: res.status.desc 
                    })
                    $('#saveTableViewModal').modal('hide')
                    $('#selectMethodModal').modal('hide')
                    $('#confirmOverwriteModal').modal('hide')
                    this.getTableViewF()
                }
            })
        },
        deleteTableViewF(tableViewId){
            Swal.fire({
                title: this.$ml.get('DELETE_RECORD'),
                text: this.$ml.get('DELETE_TABLE_VIEW_CONFIRM'),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: '#d33',
                confirmButtonText: this.$ml.get('DELETE_RECORD_CONFIRM_BTN_TXT'),
                cancelButtonText: this.$ml.get('CANCEL'),
                customClass:{
                    icon:'custom-delete-warning',
                    cancelButton:'custom-delete-cancel-button'
                },
                reverseButtons:true
            }).then((result)=>{
                if(result.isConfirmed){
                    var form = {}
                    form.tableViewId = tableViewId
                    this.deleteTableView(form).then((res)=>{
                        return res
                    }).then((res)=>{
                        if(res.status.code=="0"){
                            this.$notify({ 
                                group: 'foo',
                                type: 'success', 
                                title: this.$ml.get('SUCCESSFUL'),
                                text: res.status.desc 
                            })
                            this.getTableViewF()
                        }
                    })
                }
            })
        },
    },
    computed:{
        ...mapState(['baseUrl','windowWidth','maxMobilSize','maxTabletSize']),
    },
    mounted(){
        this.getTableViewF()
        $(this.$refs.vuemodal).on("hidden.bs.modal", this.modalHidden)
        $('#bulkUpdate').on('hidden.bs.modal',this.clearBulkUpdateModal);
        if(screen.height>720){
            this.pagingSize=30
        }else{
            this.pagingSize=30
        }

        if(this.$ml.current=="en"){
            this.exportLang="eng"
        }
        else{
            this.exportLang="tur"
        }

    },
    created(){
        this.getContacts()
    }
}
</script>

<style scoped>
.modal .animation-content .modal-card {
  overflow: visible !important;
}

.modal-card-body {
  overflow: visible !important;
}

.import-btn{   
    border: 1px solid #3767a0;
    padding: 4px;
    margin-top: 7px;
    cursor: pointer;
    font-size: 12px;
}
.import-btn:hover{
    background-color:#3767a0;
    color: #FFF;;
}
.pageTitleDiv{
      background-color: #fff;
      /* position: sticky; */
      top: 60px;
      z-index: 99;
  }    
  .pageTitleDiv2{
      display: none;
  }

  @media (max-width: 992px){
      .pageTitleDiv{
      display: initial;
  }
      .pageTitleDiv2{
      display: inline-block;
      margin-bottom: 0 !important;
  }
  @media(max-width: 768px){
        .btn-crm-secondary {
            background-color: #f2f2f2 !important;
        }
    }
}
</style>
